<template>
  <b-modal
    :title="title"
    v-model="showCloseModal"
    :ok-disabled="editDisabled"
    @ok.prevent="submit"
    size="lg"
    @cancel.prevent="cancel"
    :no-close-on-backdrop=true
  >
    <b-form v-if="form" @submit.prevent>
      <b-form-group
        v-if="isPresent('name')"
        :label="getTitle('name', 'Title')"
        label-for="project-metric-name"
        invalid-feedback="Please fill out this field"
      >
        <b-form-input
          id="project-metric-name"
          v-model.trim="form.name"
          required
          :disabled="editDisabled"
          :autofocus="!showCloseFields"
          maxlength="100"
          :state="
            errors.length == 0
              ? null
              : errors.length == 0
              ? null
              : form.name.length > 0
          "
        ></b-form-input>
      </b-form-group>
      <b-form-group
        v-if="isPresent('description')"
        :label="getTitle('description')"
        label-for="project-metric-description"
      >
        <b-form-textarea
          id="project-metric-description"
          v-model.trim="form.description"
          :disabled="editDisabled"
          maxlength="1000"
          rows="3"
        ></b-form-textarea>
      </b-form-group>
      
            <!-- This is for only the Closed Section -->
      <b-row v-if="!this.meetingId == '' && this.mode=='Close'">
        <b-col cols="4" v-if="isPresent('dateResolved')">
          <b-form-group
            :label="getTitle('dateResolved', 'Date Resolved')"
            label-for="project-metric-resolution-date"
          >
            <b-form-datepicker
                id="project-metric-resolution-date"
              v-model="todaysNewDate"
                :disabled="editDisabled"
                size="sm"
                placeholder="mm/dd/yyyy"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="4" v-if="isPresent('timeSaved')">
          <b-form-group
            :label="timeSavedTitle"
            label-for="project-metric-time-saved"
          >
            <b-form-input
              id="project-metric-time-saved"
              :disabled="editDisabled"
              v-model.trim="form.timeSaved"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4" v-if="isPresent('costSaved')">
          <b-form-group
            :label="costSavedTitle"
            label-for="project-metric-cost-saved"
          >
            <b-form-input
              id="project-metric-cost-saved"
              :disabled="editDisabled"
              v-model.trim="form.costSaved"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- This is for only the Closed Section -->
      <b-row v-if="!this.meetingId == '' && this.mode=='Close'">
         <b-col cols="4" v-if="isPresent('resolvedBy')">
          <b-form-group
            :label="getTitle('resolvedBy', 'Who Resolved')"
            label-for="project-metric-resolved-user"
          >
            <b-form-select
              id="project-metric-resolved-user"
              :disabled="editDisabled"
              v-model="form.resolvedBy"
            >
              <option value="Contractor">Contractor</option>
              <option value="Owner">Owner</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4" v-if="isPresent('mitigationMethod')">
          <b-form-group
            :label="getTitle('mitigationMethod', 'Mitigation Method')"
            label-for="project-metric-mitigation-method"
          >
            <b-form-select
              id="project-metric-mitigation-method"
              :disabled="editDisabled"
              v-model="form.mitigationMethod"
            >
              <option value="Partnering">Partnering</option>
              <option value="Contract Work">Contract Work</option>
              <option value="VECP">VECP</option>
              <option value="Change Order (non VECP)">
                Change Order (non VECP)
              </option>
              <option value="Potential Claim">Potential Claim</option>
              <option value="Other">Other</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            v-if="
              isPresent('mitigationMethodData') &&
              (form.mitigationMethod === 'VECP' ||
                form.mitigationMethod === 'Change Order (non VECP)')
            "
            label="Change Order #"
            label-for="project-metric-mitigation-method-data"
          >
            <b-form-input
              id="project-metric-mitigation-method-data"
              :disabled="editDisabled"
              v-model="form.mitigationMethodData"
              maxlength="50"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="
              isPresent('mitigationMethodData') &&
              form.mitigationMethod === 'Potential Claim'
            "
            label="Potential Claim #"
            label-for="project-metric-mitigation-method-data"
          >
            <b-form-input
              id="project-metric-mitigation-method-data"
              :disabled="editDisabled"
              v-model.trim="form.mitigationMethodData"
              maxlength="50"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
            <!-- This is for only the Closed Section -->
      <b-row class="align-items-start">
        <b-col>
          <b-form-group
            :label="getTitle('resolutionReason', 'Resolution Reason')"
            label-for="project-metric-resolution-reason"
          >
            <multiselect
              v-model="projectMetricResolutions"
              :options="otherMetricResolutions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Pick Resolution Reason"
              label="name"
              track-by="name"
              :preselect-first="false"
              class="normalFontSize"
              :show-labels="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col v-if="isPresent('resolution')">
          <b-form-group
            :label="getTitle('resolution', 'Resolution Comment')"
            label-for="project-metric-resolution"
          >
            <b-form-textarea
              id="project-metric-resolution"
              v-model.trim="form.resolution"
              rows="4"
              :disabled="editDisabled"
              :autofocus="!showAddFields"
              maxlength="1000"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col v-if="isPresent('resolutionLevel')">
          <b-form-group
            :label="getTitle('resolutionLevel', 'Resolution Level')"
            label-for="project-metric-resolution-level"
          >
            <b-form-select
              id="project-metric-resolution-level"
              :disabled="editDisabled"
              v-model="form.resolutionLevel"
            >
              <option value=""></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
            <!-- This is where the Closed Section Ends -->
    </b-form>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <template v-slot:modal-ok>
      <div>
        <b-spinner v-if="sending" small label="Spinning" />
        <div v-else-if="mode === 'Edit'">Save</div>
        <div v-else-if="mode === 'Close'">Close {{ projectMetric.type }}</div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import pmMixin from "@/mixins/project-metric-mixin.js";
import Multiselect from "vue-multiselect";

export default {
  name: "CloseProjectMetricModal",
  mixins: [pmMixin],
  components: { Multiselect },
  props: {
    title: { type: String, default: "Edit Action Item" },
    mode: { type: String, default: "Edit" },
    projectMetric: { type: Object },
    projectId: String,
    possibleAssignees: { type: Array, default: () => [] },
    addTypes: {
      type: Array,
      default: () => [
        "Risk",
        "Issue",
        "Efficiency",
        "Innovation",
        "Partnership",
        "Sustainability",
      ],
    },
    dataTemplate: Object,
    presetTags: { type: Array, default: () => [] },
    meetingId: { type: String, default: "" },
  },
  data() {
    return {
      errors: [],
      showCloseModal: false,
      sending: false,
      returnToView: false,
      form: null,
      description: "",
      filterCriteria: "",
      projectMetricResolutions: [],
      otherMetricResolutions: [
        { name: "Innovation", type: "Innovation" },
        { name: "Efficiency", type: "Efficiency" },
        { name: "Partnership", type: "Partnership" },
        { name: "Sustainability", type: "Sustainability" },
      ],
      allResolutionReason: "",
      todaysNewDate: new Date().toISOString().substr(0, 10),
      showAddModal: false,
    };
  },
  watch: {
    projectMetric(newValue) {
      this.form = this.buildForm(newValue);
    },
  },
  methods: {
    show(bool = false) {
      this.returnToView = bool;
      this.form = this.buildForm(this.projectMetric);
      this.$nextTick(() => {
        this.showCloseModal = true;
      });
    },
    hide() {
      this.showCloseModal = false;
    },
    submit() {
      this.closeProjectMetric(this.form);
    },
    addProjectMetricFromParent(projectMetric) {
      this.$emit('add-Resolution-Metric', projectMetric)
      this.cancel();
    },
    cancel() {
    //   if (this.returnToView)
    //     this.$parent.viewProjectMetric(this.projectMetric.projectMetricId);
      this.reset();
      this.hide();
    },
    reset() {
      this.errors = [];
      // this.form = this.newForm();
      this.form = null;
    },
    closeProjectMetric(form) {
      this.errors = [];

      if (!this.validateProjectMetric(form)) {
        return;
      }
      if (this.projectMetricResolutions.length > 0) {
        this.showAddModal = true;
        for (let i = 0; i < this.projectMetricResolutions.length; i++) {
          if (this.projectMetricResolutions.length === 1) {
            this.allResolutionReason = this.projectMetricResolutions[i].type;
          } else {
            this.allResolutionReason +=
              this.projectMetricResolutions[i].type + ",";
          }
        }
      }

      let request = {
        ...this.projectMetric,
        type: form.type,
        name: form.name,
        projectMetricGroupId: this.projectMetric.projectMetricGroupId,
        tags: form.tags.join(","),
        description: form.description,
        dateDue: form.due,
        identifiedByRole: form.identifiedByRole,
        assignedToUsers: this.projectMetric.assignedToUsers,
        dateClosed: form.dateResolved == null? new Date (): form.dateResolved,
        resolution: form.resolution,
        resolutionLevel: form.resolutionLevel,
        dateResolved: form.dateResolved == null? new Date (): form.dateResolved,
        resolvedBy: form.resolvedBy,
        timeSaved: form.timeSaved,
        costSaved: form.costSaved,
        createdBy: this.projectMetric.createdBy,
        mitigationMethod: form.mitigationMethod,
        mitigationMethodData: form.mitigationMethodData,
        status: this.mode == "Close" ? "Closed" : this.projectMetric.status,
        participants: form.participants.join(","),
        resolutionReason:
          this.projectMetricResolutions.length == 0
            ? "N/A"
            : this.allResolutionReason,
      };
      if (form.dateResolved == null || form.dateResolved == "") {
        request.dateResolved = new Date();
        request.dateClosed = request.dateResolved;
      }

      if (this.showAddModal) {
        this.$emit("submit");
        this.projectMetricResolutions = [];
        this.allResolutionReason = "";
        this.addProjectMetric(request);
        this.showAddModal = false;

        return;
      }

      let url = `${this.$api_url}/project-metrics/update`;
      if (this.meetingId) {
        url += `?meetingId=${this.meetingId}`;
      }
      this.sending = true;
      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
          this.$emit("submit");
        })
        .catch((err) => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
          this.projectMetricResolutions = [];
          this.allResolutionReason = "";
        });
    },
    addProjectMetric(projectMetricRequest) {
      this.errors = [];

      let request = {
        projectMetricId: this.$helpers.generateUUID(),
        projectMetricGroupId: this.projectMetric.projectMetricGroupId,
        projectId: this.projectId,
        type: projectMetricRequest.resolutionReason,
        name: projectMetricRequest.name,
        status: "Open",
        tags: projectMetricRequest.tags,
        description: projectMetricRequest.description,
        dateCreated: projectMetricRequest.dateResolved,
        dateIdentified: projectMetricRequest.dateResolved,
        createdBy: projectMetricRequest.createdBy,
        assignedToUsers: this.projectMetric.assignedToUsers,
        identifiedByRole: projectMetricRequest.identifiedByRole,
        timeSaved: projectMetricRequest.timeSaved,
        costSaved: projectMetricRequest.costSaved,
        participants: projectMetricRequest.participants,
      };
      this.addProjectMetricFromParent(request);
      //request = this.applyOverrides(request);
    },
    buildForm(projectMetric) {
      if (projectMetric) {
        this.form = {
          name: projectMetric.name,
          type: projectMetric.type,
          tags: projectMetric.tags.split(","),
          description: projectMetric.description,
          due: projectMetric.dateDue
            ? this.$helpers.APIStringToInput(projectMetric.dateDue)
            : "", //May need to change this
          dateIdentified: projectMetric.dateIdentified
            ? this.$helpers.APIStringToInput(projectMetric.dateIdentified)
            : "",
          createdBy: projectMetric.createdBy.id,
          assignedTo: projectMetric.assignedToUsers.map((a) => a.userId),
          identifiedByRole: projectMetric.identifiedByRole,
          resolution: projectMetric.resolution,
          resolutionLevel: projectMetric.resolutionLevel,
          resolutionReason: projectMetric.resolutionReason,
          dateResolved: projectMetric.dateResolved
            ? this.$helpers.APIStringToInput(projectMetric.dateResolved)
            : "",
          resolvedBy: projectMetric.resolvedBy,
          mitigationMethod: projectMetric.mitigationMethod,
          mitigationMethodData: projectMetric.mitigationMethodData,
          timeSaved: projectMetric.timeSaved,
          costSaved: projectMetric.costSaved,
          participants: projectMetric.participants.split(","),
        };
        return this.form;
      } else {
        return this.newForm();
      }
    },
    newForm() {
      return {
        name: "",
        type: this.determinedType,
        description: this.description || "",
        tags: [],
        due: "",
        dateIdentified: "", //new Date().toISOString().slice(0, 10),
        createdBy: this.accountUser.userId,
        assignedTo: [],
        identifiedByRole: "",
        resolution: "",
        resolutionLevel: "",
        resolutionReason: "",
        dateResolved: this.todaysDate,
        resolvedBy: "",
        mitigationMethod: "",
        mitigationMethodData: "",
        timeSaved: "",
        costSaved: "",
        participants: [],
        allResolutionReason: "",
      };
    },
    validateProjectMetric(form) {
      const initErrors = this.errors.length;
      if (form.name.length === 0) {
        this.errors.push({ message: "Title cannot be empty" });
      }

      if (
        this.isPresent("timeSaved") &&
        form.timeSaved &&
        isNaN(form.timeSaved)
      ) {
        this.errors.push({ message: "Days Saved must be a number" });
      }
      if (
        this.isPresent("costSaved") &&
        form.costSaved &&
        isNaN(form.costSaved)
      ) {
        this.errors.push({ message: "Dollars Saved must be a number" });
      }
      if (this.form.tags.join(",").length > 500) {
        this.errors.push({ message: "Too many tags" });
      }

      return initErrors === this.errors.length;
    },
    determineType() {
      if (this.form && this.form.type) {
        return this.form.type;
      } else if (this.addTypes.length > 0) {
        return this.addTypes[0];
      } else {
        return "";
      }
    },
    applyOverrides(request) {
      if (this.dataTemplate != null && this.dataTemplate.overrides) {
        this.dataTemplate.overrides.forEach((o) => {
          if (o.actions.includes(this.mode)) {
            request[o.key] = o.value;
          }
        });
      }

      return request;
    },
    isPresent(name) {
      return this.isIncluded(name, this.visibleFields);
    },
    setDescription(description) {
      // Description needs to be set before the form gets created
      this.description = description;
    },
    addTag(tag) {
      // Adds a single tag after the form is created
      this.form.tags.push(tag);
    },
    toAssigneeOption(user) {
      return { value: user.userId, text: user.name };
    },
    searchFilter(value) {
      return value.text
        .toLowerCase()
        .includes(this.filterCriteria.toLowerCase());
    },
    getChampName(id) {
      for (var i in this.assigneeOptions) {
        if (this.assigneeOptions[i].value == id)
          return this.assigneeOptions[i].text;
      }
      return "";
    },
    removeFromChamps(champ) {
      for (var i in this.form.assignedTo) {
        if (this.form.assignedTo[i] == champ) this.form.assignedTo.splice(i, 1);
      }
    },
  },
  computed: {
    todaysDate() {
      let date = new Date(),
        month =
          date.getMonth() >= 9
            ? date.getMonth() + 1
            : `0${date.getMonth() + 1}`,
        day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;

      return `${date.getFullYear()}-${month}-${day}`;
    },
    unselectedTags() {
      return this.presetTags.filter((t) => this.form.tags.indexOf(t) === -1);
    },
    assigneeOptions() {
      return this.possibleAssignees.map((a) => this.toAssigneeOption(a));
    },
    showAddFields() {
      return this.mode === "Add" || this.mode === "Edit";
    },
    showCloseFields() {
      return (
        this.mode === "Close" ||
        (this.mode === "Edit" &&
          this.projectMetric &&
          this.projectMetric.status == "Closed")
      );
    },
    editDisabled() {
      return (
        this.projectMetric != null &&
        this.projectMetric.status === "Closed" &&
        !this.isSystemAdmin
      );
    },
    template() {
      if (this.context == null) {
        return null;
      }

      let type = "";
      if (this.projectMetric != null) {
        type = this.projectMetric.type;
      } else {
        type = this.determinedType;
      }
      let value = this.context.projectMetricTemplates.find(
        (t) => t.typeName === type
      );

      return value || null;
    },
    visibleFields() {
      let fields = [];
    if (this.mode === "Close") {
        fields = [
          "resolution",
          "resolutionLevel",
          "dateResolved",
          "resolvedBy",
          "timeSaved",
          "costSaved",
          "mitigationMethod",
          "mitigationMethodData",
          "resolutionReason",
        ];
      } 
      return fields;
    },
    getTypeOptions() {
      return this.addTypes.map((t) => ({ value: t, text: t }));
    },
    timeSavedTitle() {
      return !this.form.timeSaved ||
        this.form.timeSaved == 0 ||
        isNaN(this.form.timeSaved)
        ? "Days Impacted"
        : this.form.timeSaved > 0
        ? "Days Saved"
        : this.form.timeSaved < 0
        ? "Days Lost"
        : "";
    },
    costSavedTitle() {
      return !this.form.costSaved ||
        this.form.costSaved == 0 ||
        isNaN(this.form.costSaved)
        ? "Dollars Impacted"
        : this.form.costSaved > 0
        ? "Dollars Saved"
        : this.form.costSaved < 0
        ? "Dollars Lost"
        : "";
    },
    determinedType() {
      if (this.form && this.form.type) {
        return this.form.type;
      } else if (this.addTypes.length > 0) {
        return this.addTypes[0];
      } else {
        return "";
      }
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.custom-select {
  width: 100%;
}
.button-tag-parent > div > div > div {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  align-content: flex-start;
}
.normalFontSize {
  font-size: 12px;
}
</style>